import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions, NavigationError } from '@angular/router';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ApprovePageComponent } from './approve-page/approve-page.component';
import { PermissionGuardService } from './services/permission-guard.service';
import { ForcedPasswordChangeGuard } from './services/forced-password-change.guard';
import { EmptyPageComponent } from './components/empty-page/empty-page.component';
import { ProviderTokenComponent } from './components/provider-token/provider-token.component';

/** Lazy-load chunk failures: reload (Router.errorHandler removed in Angular 19). */
function handleNavigationChunkError(navError: NavigationError): void {
  const error: any = navError?.error ?? navError;
  const chunkFailed =
    error?.message?.includes('ChunkLoadError') ||
    error?.message?.includes('Loading chunk') ||
    error?.name === 'ChunkLoadError';

  if (chunkFailed) {
    console.warn('Chunk load failed. Reloading...');
    window.location.reload();
  }
}

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
  useHash: true,
  errorHandler: handleNavigationChunkError,
};
const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [PermissionGuardService],
    data: { screenId: '-1' },
  },
  { path: 'sign-extension', component: EmptyPageComponent, canActivate: [ForcedPasswordChangeGuard] },
  { path: 'digital-signature-manual', loadChildren: () => import('./digital-signature-manual/digital-signature-manual.module').then(m => m.DigitalSignatureManualModule), canActivate: [PermissionGuardService], data: { screenId: '26' } },
  { path: '', pathMatch: 'full', component: EmptyPageComponent, canActivate: [ForcedPasswordChangeGuard] },

  {
    path: 'digital-signature',
    loadChildren: () =>
      import('./digital-signature/digital-signature.module').then(m => m.DigitalSignatureModule),
    canActivate: [ForcedPasswordChangeGuard],
    data: { screenId: '23' },
  },
  { path: 'error-page', component: ErrorPageComponent, canActivate: [ForcedPasswordChangeGuard] },
  { path: 'provider', component: ProviderTokenComponent, canActivate: [ForcedPasswordChangeGuard] },
  { path: 'approve-page', component: ApprovePageComponent, canActivate: [ForcedPasswordChangeGuard] },
  {
    path: 'confirmation',
    loadChildren: () => import('./confirmation/confirmation-page.module').then(m => m.ConfirmationPageModule),
    canActivate: [ForcedPasswordChangeGuard],
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '**', pathMatch: 'full', component: PagenotfoundComponent, canActivate: [ForcedPasswordChangeGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
